export default __webpack_public_path__ + "static/media/Me-O Persian Adult Cat Food Dry.521180e3.png";